module.exports = __webpack_public_path__ + "assets/caret-down.70d5b080.svg";